<template>
  <section class="info-white">
		<div class="content-wrapper">
			<h2><span>会社概要</span></h2>
			<table border="1" class="company">
				<tr>
					<td>社　名</td><td>株式会社Yagish（ヤギッシュ）</td>
				</tr>
				<tr>
					<td>設　立</td><td>2021年9⽉1⽇</td>
				</tr>
				<tr>
					<td>本社所在地</td><td>東京都渋谷区恵比寿西二丁目3番12号</td>
				</tr>
				<tr>
					<td>経 営 陣</td><td>代表取締役 CEO ⾦ 相集（キム サンジプ）<br>
					専務取締役 COO 齋藤 由紀夫（サイトウ ユキオ）	
					</td>
				</tr>
				<tr>
					<td>資 本 金</td><td>9,500万円（資本準備⾦含む）</td>
				</tr>
				<tr>
					<td>事業内容</td><td>
					・履歴書作成サービスの提供（⽇本最⼤級）<br>
					・キャリア形成コンテンツの提供<br>
					・求⼈求職のAIマッチングサービスの提供
					</td>
				</tr>
			</table>
		</div>
	</section>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {}
</script>



